import React from 'react';

/**
 * WorkflowProgress - Shows workflow completion status
 *
 * Displays required steps with their completion status:
 * Content ✓ → Image ○ → Publish (2/3)
 */
const WorkflowProgress = ({ tabs }) => {
  const requiredTabs = tabs.filter(t => t.required);
  const completedCount = requiredTabs.filter(t => t.complete).length;

  if (requiredTabs.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 text-xs flex-wrap">
      {requiredTabs.map((tab, idx) => (
        <React.Fragment key={tab.id}>
          <span className={tab.complete ? 'text-green-400' : 'text-gray-500'}>
            {tab.label} {tab.complete ? '✓' : '○'}
          </span>
          {idx < requiredTabs.length - 1 && (
            <span className="text-gray-600">→</span>
          )}
        </React.Fragment>
      ))}
      <span className="ml-2 text-gray-500 bg-gray-800 px-2 py-0.5 rounded">
        {completedCount}/{requiredTabs.length}
      </span>
    </div>
  );
};

export default WorkflowProgress;
